import { type Metric } from '../vessel_data'

export enum PropellerMetric {
  propellersPortPitch = 'propellersPortPitch',
  propellersStbdPitch = 'propellersStbdPitch',
  propellersPortSpeed = 'propellersPortSpeed',
  propellersStbdSpeed = 'propellersStbdSpeed'
}

export type PropellerMetricName = keyof typeof PropellerMetric

export type PropellerMetrics = Record<PropellerMetricName, Metric>

export const allPropellerMetricNames: PropellerMetricName[] = Object.values(PropellerMetric)
